import styled from 'styled-components'

const Styled500 = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.playfairDisplay};
  h1 {
    font-family: ${({ theme }) => theme.fonts.playfairDisplay};
  }
`

export default Styled500
